export default function TierCounter({
  legend,
  grand,
  collector,
}: {
  legend: number;
  grand: number;
  collector: number;
}) {
  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="flex items-center gap-1 text-mlbb-legend">👑 {legend}</span>
      <span className="flex items-center gap-1 text-mlbb-grand">⭐ {grand}</span>
      <span className="flex items-center gap-1 text-mlbb-collector">💠 {collector}</span>
    </div>
  );
}
